import {accessToken} from "../components/core/auth-service/auth-service";
import {
  GET_CUSTOMER_DATA_START,
  GET_CUSTOMER_DATA_SUCCESS,
  GET_CUSTOMER_DATA_FAILURE,
  RESET_ON_IMPERSONATION
} from "./actionTypes";
import {ErrorResponseWrapper} from "../model/ErrorResponseWrapper";
import getConfig from '../environment';

export const getCustomerDataBegin = () => ({
  type: GET_CUSTOMER_DATA_START,
  payload: {}
});

export const getCustomerDataSuccess = (payload) => ({
  type: GET_CUSTOMER_DATA_SUCCESS,
  payload: payload
});

export const getCustomerDataFailure = (errors) => ({
  type: GET_CUSTOMER_DATA_FAILURE,
  payload: {errors}
});

export const resetOnImpersonation = () => ({
  type: RESET_ON_IMPERSONATION,
})

const CUSTOMER_DATA_API = getConfig()?.fileUploadApi;

export async function getCustomerDataFromApi(dispatch:any) {
  const getCustomerDataUrl = `${CUSTOMER_DATA_API}/customers`;
  dispatch(getCustomerDataBegin());
  return fetch(getCustomerDataUrl, {
    headers: {
      'Authorization': `Bearer ${await accessToken()}`,
      'Accept': 'application/json'
    }
  })
  .then(response => {
    console.log('customer info response before processing = ', response);
      if(!response.ok) {
        throw new ErrorResponseWrapper(response)
      } else {
        return response.json()
      }
  })
  .then(data => {
    dispatch(getCustomerDataSuccess(data))
  })
  .catch((errorResponse) => {
    console.log('the error = ', errorResponse);
    if(errorResponse instanceof ErrorResponseWrapper) {
      dispatch(getCustomerDataFailure(errorResponse.getErrorMessages()))
    } else {
      const errorsObject = [errorResponse.message];
      dispatch(getCustomerDataFailure(errorsObject));
    }
  })
}

export function resetReduxOnImpersonation(dispatch) {
  dispatch(resetOnImpersonation());
}
